import { createApp } from "vue";
import Antd from "ant-design-vue";
import App from "./App.vue";
import "ant-design-vue/dist/reset.css";
import router from "./router";
import pinia from "./store/index";
import * as AntdIcons from "@ant-design/icons-vue";
import "./permission";
import persist from "pinia-plugin-persistedstate";
pinia.use(persist);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import piana from "./store/index"; // 引入插件
piana.use(piniaPluginPersistedstate);
import "./router/guard"; // 确保这行存在于 main.ts 中
//全局获取携带
import { OpenAPI } from "../generated/core/OpenAPI";
import { GET_TOKEN } from "@/utils/token";
// 或者动态获取 token
OpenAPI.TOKEN = async (options) => {
  // 在这里可以根据 options 动态生成或获取 token
  return GET_TOKEN() as string;
};
const app = createApp(App);
// 全局注册所有 Ant Design Vue 图标组件
Object.keys(AntdIcons).forEach((key) => {
  app.component(key, (AntdIcons as any)[key]);
});
app.use(router).use(pinia).use(Antd).mount("#app");
